import { render, staticRenderFns } from "./ManageBulletins.vue?vue&type=template&id=051f9998"
import script from "./ManageBulletins.vue?vue&type=script&lang=js"
export * from "./ManageBulletins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports